// extracted by mini-css-extract-plugin
export default {"sidebar-footer":"styles_sidebar-footer__RBCTC","sidebar-footer-close":"styles_sidebar-footer-close__+ol6b"};